// hooks/useOperatorNavigate.js
import { navigate } from "@reach/router";
import { extractOperatorName, navMode } from "constants/config";


const operator = extractOperatorName(window.location.href, "after");


export const useOperatorNavigate = () => {
  return (to, options) => {
    if (!to.startsWith("/")) {
      to = `/${to}`;
    }

    const fullPath =
      navMode === "prod" && operator ? `/${operator}${to}` : to;

    navigate(fullPath, options);
  };
};


// export const useOperatorNavigate = () => {
//     return (to, options) => {
//       if (!to.startsWith("/")) {
//         to = `/${to}`;
//       }
  
//       // Handle missing operator in prod
//       if (navMode === "prod" && !operator) {
//         console.warn("Operator name not found in URL!");
//         // Optionally: redirect to a fallback
//         // navigate("/error/missing-operator");
//         return;
//       }
  
//       const fullPath =
//         navMode === "prod" && operator ? `/${operator}${to}` : to;
  
//       navigate(fullPath, options);
//     };
//   };